import 'reflect-metadata';
import { IMetaPropretyArgs, IPropretyAttribute } from '../_models/IEntityMetaData';

export const METADATA_KEYPREFIX = '__metaData_';

export type DecoratorType =
  | 'PropretyAttributes'
  | 'NestedProperty'
  | 'NavigationProperty'
  | 'Validation';

export const Decorators = {
  PropretyAttributes: 'PropretyAttributes',
  NestedProperty: 'NestedProperty',
  NavigationProperty: 'NavigationProperty',
  Validation: 'Validation'
} as const;




export function PropretyAttributes(options: IMetaPropretyArgs) {
  return function (target: any, propertyKey: string) {
    configurePropretyMetadata(propertyKey, target, options, Decorators.PropretyAttributes);
  };
}
export function NestedProperty(options: Partial<IMetaPropretyArgs> = {}) {
  return function (target: any, propertyKey: string) {
    configurePropretyMetadata(propertyKey, target, options, Decorators.NestedProperty);
  };
}

export function NavigationProperty(options: Partial<IMetaPropretyArgs> = {}) {
  return function (target: any, propertyKey: string) {
    configurePropretyMetadata(propertyKey, target, options, Decorators.NavigationProperty);
  };
}

export function Validation(options: Pick<IMetaPropretyArgs, 'pattern' | 'minLength' | 'maxLength' | 'propertyType' | 'validationErrorMessage' | 'crossValidationFieldName'> = {}) {
  return function (target: any, propertyKey: string) {
    configurePropretyMetadata(propertyKey, target, options, Decorators.Validation);
  };
}

function configurePropretyMetadata(propertyKey: string, target: any, options: IMetaPropretyArgs, decoratorType: string) {
  const accessKey = `${METADATA_KEYPREFIX}${propertyKey}`;
  if (!target[accessKey]) {
    target[accessKey] = new Map<string, IMetaPropretyArgs>();
  }
  target[accessKey].set(decoratorType, options);
}
